import React, { useState, useEffect} from 'react';
import { ComboBox, DropdownSkeleton, FormLabel, Tooltip} from 'carbon-components-react';
import { useFormContext } from 'react-hook-form';

const FormComboBox = ({label, name, items, itemValueField, itemTextField, disabled, itemToString, onChange, onInputChange, helperText, tooltipContent, props, downShift}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    const [objValue, setObjValue] = useState(null);
    const watcher = watch(name);

    disabled = disabled ?? false;
    itemValueField = itemValueField ?? "id";
    itemTextField = itemTextField ?? "name";

    let obj = formState.errors[name];
    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }
    useEffect(() => {
        if(!watcher)
            setObjValue(null);
        if(items)
            setObjValue(items.find(s => s.id === watcher));
    }, [watcher]);

    const change = (e) => {
        if(onChange)
            onChange(e);
        if(e)
            setValue(name, e.selectedItem?.id);
            
        trigger(name);
     
    }


    return ( 
        <div className="mb-6">
        <FormLabel>
            {
            tooltipContent ?
            <Tooltip triggerText={label}>
                {tooltipContent}
            </Tooltip> 
            : <>{label}</>
            }
        </FormLabel>
        {!items ? <DropdownSkeleton />
        :
            <ComboBox
                id={`ddl-${name}`} {...register(name)} 
                helperText={helperText}
                label={label}
                items={items}
                itemToString={itemToString? itemToString : (item) => (item ? item[itemTextField] : '')}
                onChange={change}
                onInputChange={onInputChange ? onInputChange : {}}
                invalidText={obj?.message} 
                invalid={!!obj}
                downshiftProps={downShift} 
                {...props}
            />
        }
        </div>
     );
}
 
export default FormComboBox;